import styled, {keyframes} from 'styled-components'

// Spinning animation
const spin = keyframes`
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
`

// Pulsing animation for the message
const pulse = keyframes`
	0%, 100% {
		opacity: 1;
	}
	50% {
		opacity: 0.5;
	}
`

const getSizeStyles = (size) => {
	switch (size) {
		case 'small':
			return {
				width: '20px',
				height: '20px',
				borderWidth: '2px',
			}
		case 'large':
			return {
				width: '60px',
				height: '60px',
				borderWidth: '4px',
			}
		case 'medium':
		default:
			return {
				width: '40px',
				height: '40px',
				borderWidth: '3px',
			}
	}
}

const getColorStyles = (color, theme) => {
	switch (color) {
		case 'white':
			return {
				borderColor: `${theme.color.white} transparent ${theme.color.white} transparent`,
			}
		case 'grey':
			return {
				borderColor: `${theme.color.grey3} transparent ${theme.color.grey3} transparent`,
			}
		case 'primary':
		default:
			return {
				borderColor: `${theme.color.major} transparent ${theme.color.major} transparent`,
			}
	}
}

const Style = {
	SpinnerContainer: styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 12px;

		${({$overlay}) =>
			$overlay &&
			`
			position: fixed;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background-color: rgba(0, 0, 0, 0.5);
			z-index: 9999;
		`}
	`,

	Spinner: styled.div`
		${({$size}) => {
			const {width, height, borderWidth} = getSizeStyles($size)
			return `
				width: ${width};
				height: ${height};
				border: ${borderWidth} solid;
			`
		}}

		${({$color, theme}) => {
			const {borderColor} = getColorStyles($color, theme)
			return `border-color: ${borderColor};`
		}}

		border-radius: 50%;
		animation: ${spin} 1s linear infinite;
	`,

	SpinnerCircle: styled.div`
		display: none; /* Not needed for this simple spinner */
	`,

	Message: styled.p`
		margin: 0;
		color: ${({theme}) => theme.color.grey4};
		text-align: center;
		animation: ${pulse} 1.5s ease-in-out infinite;

		${({$size, theme}) => {
			switch ($size) {
				case 'small':
					return theme.font.extra_small
				case 'large':
					return theme.font.medium
				case 'medium':
				default:
					return theme.font.small
			}
		}}

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			${({theme}) => theme.font.extra_small};
		}
	`,
}

export default Style
